(function () {
  const container = document.querySelector('[data-rever-size-banner]');
  if (!container || container.dataset.reverInitialized === '1') return;
  container.dataset.reverInitialized = '1';

  const CONFIG = {
    TRAFFIC_ALLOCATION: 95,
    STORAGE_KEY: 'rever_visitor_id_hashed',
    GROUP_KEY: 'rever_ab_group',
    API_URL: 'https://3o3sepchz3wyufedqsjmeben6e0yemfo.lambda-url.eu-west-3.on.aws/size_suggestions',
    FINAL_API_TARGET: 'https://api.byrever.com/v1/public/analytics/get_product_size_suggestion',
  };

  const ctx = {
    productId: container.dataset.productId || '',
    storeId: container.dataset.storeId || '',
    language: container.dataset.language || 'en',
    country: normalizeCountry(container.dataset.country),
    customerId: container.dataset.customerId || '',
    customerEmail: container.dataset.customerEmail || '',
  };

  function normalizeCountry(c) {
    const v = (c || '').toString().trim().toUpperCase();
    return v.length === 2 ? v : 'WW';
  }

  function hashString(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = ((hash << 5) - hash) + str.charCodeAt(i);
      hash |= 0;
    }
    return 'rev_' + Math.abs(hash).toString(16);
  }

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  async function getIP() {
    try {
      const r = await fetch('https://api.ipify.org?format=json');
      const d = await r.json();
      return d.ip;
    } catch (e) {
      return '0.0.0.0';
    }
  }

  function resolveHashedIdentity(currentIp) {
    const stored = localStorage.getItem(CONFIG.STORAGE_KEY);
    if (stored) return stored;

    let id;
    if (ctx.customerId) {
      id = hashString('shop_' + ctx.customerId);
    } else {
      const shopifyY = getCookie('_shopify_y');
      id = shopifyY ? hashString('sh_y_' + shopifyY) : hashString('ip_' + currentIp);
    }
    localStorage.setItem(CONFIG.STORAGE_KEY, id);
    return id;
  }

  function tagCart(visitorId, group) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          rever_size_suggestions_id: visitorId,
          rever_size_suggestions_group: group,
        },
      }),
    });
  }

  async function init() {
    const ip = await getIP();
    const visitorId = resolveHashedIdentity(ip);

    const bucket = parseInt(visitorId.replace('rev_', ''), 16) % 100;
    const abGroup = bucket < CONFIG.TRAFFIC_ALLOCATION ? 'see_banner' : 'control';
    localStorage.setItem(CONFIG.GROUP_KEY, abGroup);

    const body = {
      product_id: ctx.productId,
      language: ctx.language,
      store_id: ctx.storeId,
      country: ctx.country,
      email: ctx.customerEmail,
      ip_address: ip,
      rever_ab_group: abGroup,
      rever_visitor_id: visitorId,
    };

    try {
      const res = await fetch(CONFIG.API_URL, {
        method: 'POST',
        headers: {
          'X-Rever-Final-Url': CONFIG.FINAL_API_TARGET,
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        body: JSON.stringify(body),
      });
      if (!res.ok) return;

      const data = await res.json();
      if (data && data.suggestion) tagCart(visitorId, abGroup);
      if (!data || !data.suggestion_copy || abGroup === 'control') return;

      container.innerHTML = data.suggestion_copy;
    } catch (e) {
      console.error('REVER Error:', e);
    }
  }

  init();
})();